import { render, staticRenderFns } from "./live-top.vue?vue&type=template&id=7fec86a0&scoped=true&"
import script from "./live-top.vue?vue&type=script&lang=js&"
export * from "./live-top.vue?vue&type=script&lang=js&"
import style0 from "./live-top.vue?vue&type=style&index=0&id=7fec86a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fec86a0",
  null
  
)

export default component.exports